import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8b2d174"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-center height-100 router-step" }, " Router ", -1))
const _hoisted_4 = [
  _hoisted_3
]

import { isStepSkipped } from "@/flow/utils/skipUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterBox',
  props: {
    listIndex: {},
    step: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex box-210 stepBoxCount",
    id: `router-unique-${_ctx.step?.uniqueId}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card border-0 border-radius-12 square-div-120 bg-purple router-section router-step", { 'activity-router-skipped': _unref(isStepSkipped)(_ctx.step) }]),
      id: `router${_ctx.listIndex}`
    }, _hoisted_4, 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})